import { Container, Typography, Button } from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import BackButton from "~/components/common/backButton";
import React, { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import StickyFooter from "~/components/common/stickyFooter/StickyFooter";
import MuiStylesTitleContainer from "~/components/common/titleContainer/MuiStylesTitleContainer";
import SpinnerLoading from "../spinnerLoading/SpinnerLoading";
import { useSelector } from "react-redux";

const TitleContainer = (props) => {
    const { t } = useTranslation();
	const {
		handleClick,
		title,
		subtitle,
		children,
		footer,
		loading,
		styles,
		imageVisible = false,
		backgroundNew = false,
		showGradient = true,
		showFooter = true,
		rightElement,
		imageCustom,
		token,
		childrenStyle,
		labelButton,
		onRedirect,
		floatingButton = false,
		showOpacityFooter = false,
		headerClassName
	} = props;
	
	const [imageCategory, setImageCategory] = useState(null);

	useEffect(() => {
		const imageSelectedCategory = sessionStorage.getItem("imageCategory");
		if (imageSelectedCategory) {
			try {
				const parsed = JSON.parse(imageSelectedCategory);
				setImageCategory(parsed);
			} catch (error) {
				setImageCategory(null);
			}
		} else {
			setImageCategory(null);
		}
	}, []);

	useEffect(() => {
		const handleCustomStorageChange = (event) => {
			if (event.detail?.key === "imageCategory") {
				setImageCategory(event.detail?.value || null);
			}
		};
		window.addEventListener('customStorageChange', handleCustomStorageChange);
		return () => {
			window.removeEventListener('customStorageChange', handleCustomStorageChange);
		};
	}, []);

	const { business } = useSelector((store) => store.business);
	const { user } = useSelector((store) => store.auth);
	const imageUrl =
		imageCustom ||
		business?.photos[0]?.url ||
		(business?.categories?.length === 1
			? business?.categories[0]?.image
			: business?.photos[0]?.url
			? business?.photos[0]?.url
			: imageCategory);
	
	const classes = MuiStylesTitleContainer({ imageUrl, imageVisible, backgroundNew, dateCreatedBusiness: business?.createdAt, showGradient, imageCustom });

	return (
		<Fragment>
			<SpinnerLoading loading={loading} />
				<Container className={classes.container}>
					{(handleClick || title || subtitle) && (
						<header className={`${classes.header} ${headerClassName || ''}`} style={props.headerStyle}>
							{(handleClick || title) && (
								<div style={{ display: "flex", alignItems: "center" }}>
									{handleClick && (
										<>
											<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: rightElement ? '100%' : '' }}>
												<div style={{ cursor: "pointer", color: rightElement ? "#fff" : "" }}>
													<BackButton onClick={handleClick}/>
												</div>
												{rightElement && (
													<div>
														{rightElement}
													</div>
												)}
											</div>
										</>
									)}
									{title && (
										<div style={{ width: "-webkit-fill-available" }}>
											<Typography variant="h3" className={classes.title}>
												{title}
											</Typography>
										</div>
									)}
								</div>
							)}
							{subtitle &&
								(subtitle && typeof subtitle === "string" ? (
									<Typography style={{ width: styles }} className={classes.subtitle}>
										{subtitle}
									</Typography>
								) : (
									subtitle
								))}
						</header>
					)}
					{floatingButton && (
						<div className={classes.containerFloatingButton}>
							<Button className={classes.floatingButton} type="button" onClick={onRedirect}>
								{labelButton ? labelButton : t("Discover packages")}
							</Button>
						</div>
					)}
					<div className={classes.children} style={childrenStyle}>
						{children}
					</div>
					
					{(footer && !loading) && <StickyFooter backgroundNew={backgroundNew} user={user} showFooter={showFooter} token={token} showOpacityFooter={showOpacityFooter}>{footer}</StickyFooter>}
				</Container>
		</Fragment>
	);
};
export default withRouter(TitleContainer);
